module.exports = __webpack_public_path__ + "static/media/ntuc-link-desktop-image.cac01ae9.jpg";